import { createSlice } from "@reduxjs/toolkit";
import { storeSettingTypes } from "../utils";

const storeSettingsSlice = createSlice({
  name: "storeSettings",

  initialState: {
    platform: null,
    storeSubDomain: null,
    isJaneDoeTestMode: null,
    brandLogo: null,
    baseURL: null,
    autoOrderId: null,
    autoCID: null,
    storeUniqueID: null,
    is404: null,
    themeConfigOthers: null,
    themeConfig: null,
    themeConfigDa: null,
    themeConfigDe: null,
    themeConfigEn: null,
    themeConfigEs: null,
    storeName: null,
    storePlan: null,
    testOrder: null,
    sessionID: null,
    isChatGPTEnabled: null,
  },

  reducers: {
    updateSetting: (state, action) => {
      const { key, value } = action.payload;

      switch (key) {
        case storeSettingTypes.UPDATE_PLATFORM:
          state.platform = value;
          break;
        case storeSettingTypes.UPDATE_SUBDOMAIN:
          state.storeSubDomain = value;
          break;
        case storeSettingTypes.UPDATE_IS_JOHN_DOE_TEST_MODE:
          state.isJaneDoeTestMode = value;
          break;
        case storeSettingTypes.UPDATE_BRAND_LOGO:
          state.brandLogo = value;
          break;
        case storeSettingTypes.UPDATE_BASE_URL:
          state.baseURL = value;
          break;
        case storeSettingTypes.UPDATE_AUTO_ORDER_ID:
          state.autoOrderId = value;
          break;
        case storeSettingTypes.UPDATE_AUTO_CID:
          state.autoCID = value;
          break;
        case storeSettingTypes.UPDATE_STORE_UNIQUE_ID:
          state.storeUniqueID = value;
          break;
        case storeSettingTypes.UPDATE_IS_404:
          state.is404 = value;
          break;
        case storeSettingTypes.UPDATE_THEME_CONFIG_OTHERS:
          state.themeConfigOthers = value;
          break;
        case storeSettingTypes.UPDATE_THEME_CONFIG:
          state.themeConfig = value;
          break;
        case storeSettingTypes.UPDATE_THEME_CONFIG_DA:
          state.themeConfigDa = value;
          break;
        case storeSettingTypes.UPDATE_THEME_CONFIG_DE:
          state.themeConfigDe = value;
          break;
        case storeSettingTypes.UPDATE_THEME_CONFIG_EN:
          state.themeConfigEn = value;
          break;
        case storeSettingTypes.UPDATE_THEME_CONFIG_ES:
          state.themeConfigEs = value;
          break;
        case storeSettingTypes.UPDATE_STORE_NAME:
          state.storeName = value;
          break;
        case storeSettingTypes.UPDATE_STORE_PLAN:
          state.storePlan = value;
          break;
        case storeSettingTypes.UPDATE_TEST_ORDER:
          state.testOrder = value;
          break;
        case storeSettingTypes.CHAT_SESSION_ID:
          state.sessionID = value;
          break;
        case storeSettingTypes.IS_CHATGPT_ENABLED:
          state.isChatGPTEnabled = value;
          break;
        default:
      }
    },
  },
});

// Export the slice
export { storeSettingsSlice };

// Export the actions
export const { updateSetting } = storeSettingsSlice.actions;

// Export the reducer
export default storeSettingsSlice.reducer;
